import { TourDefinition } from "../tourTypes";

// The first-run intro tour. Stays on the dashboard (no route navigation) and walks
// the learner through the dashboard hero + the left-nav "map". Permission-gated nav
// anchors that don't exist for a given learner are auto-skipped by the engine.
export const introTour: TourDefinition = {
  id: "intro",
  titleKey: "tour_intro_title",
  descriptionKey: "tour_intro_desc",
  iconName: "path",
  steps: [
    {
      id: "welcome",
      anchorId: "dash-welcome",
      titleKey: "tour_welcome_title",
      bodyKey: "tour_welcome_body",
      placement: "bottom",
    },
    {
      id: "streak",
      anchorId: "dash-streak",
      titleKey: "tour_streak_title",
      bodyKey: "tour_streak_body",
      placement: "bottom",
    },
    {
      id: "homeworks",
      anchorId: "nav-homeworks",
      titleKey: "tour_homeworks_title",
      bodyKey: "tour_homeworks_body",
      placement: "right",
    },
    {
      id: "learning-path",
      anchorId: "nav-learning-path",
      titleKey: "tour_learning_path_title",
      bodyKey: "tour_learning_path_body",
      placement: "right",
    },
    {
      id: "reports",
      anchorId: "nav-reports",
      titleKey: "tour_reports_title",
      bodyKey: "tour_reports_body",
      placement: "right",
    },
    {
      id: "contests",
      anchorId: "nav-contests",
      titleKey: "tour_contests_title",
      bodyKey: "tour_contests_body",
      placement: "right",
    },
    {
      id: "market",
      anchorId: "nav-market",
      titleKey: "tour_market_title",
      bodyKey: "tour_market_body",
      placement: "right",
    },
    {
      id: "plans",
      anchorId: "nav-plans",
      titleKey: "tour_plans_title",
      bodyKey: "tour_plans_body",
      placement: "right",
    },
    {
      id: "practises",
      anchorId: "nav-practises",
      titleKey: "tour_practises_title",
      bodyKey: "tour_practises_body",
      placement: "right",
    },
    {
      id: "announcements",
      anchorId: "nav-announcements",
      titleKey: "tour_announcements_title",
      bodyKey: "tour_announcements_body",
      placement: "right",
    },
    {
      id: "help",
      anchorId: "nav-help",
      titleKey: "tour_help_title",
      bodyKey: "tour_help_body",
      placement: "right",
    },
  ],
};
